<template>
  <div class="pay">
    <div class="title">选择合适的会员方案</div>
    <div class="setMeal">
      <div :class="this.id==1?'click':'noclick'" @click="choose1()">
        <div class="preferential">限时特惠</div>
        <div class="name">24+送12个月</div>
        <div class="price">￥259</div>
        <div class="originalPrice">原价￥920</div>
        <div class="buy" @click="pay1()">立即购买</div>
        <div class="activity">低至￥7.19/月 仅￥0.47/天</div>
      </div>
      <div :class="this.id==2?'click':'noclick'" @click="choose2()">
        <div class="preferential">超值推荐</div>
        <div class="name">12个月</div>
        <div class="price">￥129</div>
        <div class="originalPrice">原价￥460</div>
        <div class="buy" @click="pay2()">立即购买</div>
        <div class="activity">低至￥10.75/月 仅￥0.35/天</div>
      </div>
      <div :class="this.id==3?'click':'noclick'" @click="choose3()">
        <div class="name">6个月</div>
        <div class="price">￥99</div>
        <div class="originalPrice">原价￥235</div>
        <div class="buy" @click="pay3()">立即购买</div>
        <div class="activity">每月仅需￥16.5</div>
      </div>
      <div :class="this.id==4?'click':'noclick'" @click="choose4()">
        <div class="name">3个月</div>
        <div class="price">￥59</div>
        <div class="originalPrice">原价￥120</div>
        <div class="buy" @click="pay4()">立即购买</div>
        <div class="activity">全站资源免费使用</div>
      </div>
      <div :class="this.id==5?'click':'noclick'" @click="choose5()">
        <div class="name">1个月</div>
        <div class="price">￥39</div>
        <div class="originalPrice"></div>
        <div class="buy" @click="pay5()">立即购买</div>
        <div class="activity"></div>
      </div>
    </div>
    <div class="privilege">
      <div class="top">
        会员权限<span>/全站资源免费下载</span>
      </div>
      <div class="bottom">
        <ul>
          <li><img class="icon" src="./images/download.png">创建数据接入数量<span>不限</span></li>
          <li><img class="icon" src="./images/download.png">创建大屏数量<span>不限</span></li>
          <li><img class="icon" src="./images/download.png">报表下载<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">素材下载<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">模板库<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">模型库<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">图表库<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">共享大屏下载<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">文件导入功能<span><img src="./images/right.png"></span></li>
          <li><img class="icon" src="./images/download.png">单文件协作成员<span>不限</span></li>
          <li><img class="icon" src="./images/download.png">单文件同时可查看人数<span>不限</span></li>
          <li><img class="icon" src="./images/download.png">会员专属标识<span><img src="./images/right.png"></span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //获取消息内容
  Payment,
} from '@/assets/axios/pay/pay'
export default {
  data() {
    return {
      id: 1,
      price: 259,
      name: '24+送12个月',
      day: 1095,
    }
  },
  methods: {
    choose1() {
      this.id = 1;

    },
    choose2() {
      this.id = 2;

    },
    choose3() {
      this.id = 3;

    },
    choose4() {
      this.id = 4;

    },
    choose5() {
      this.id = 5;

    },
    pay1() {
      this.price = 259;
      this.name = '24+送12个月';
      this.day = 1095;
      var data =
      {
        total_amount: this.price,//价格（小数点后保留两位）
        Subject: this.name,//商品名称
        Days: this.day,//开通天数
      };
      Payment(data).then(res => {
        if (res.code === 200) {
          window.location.href = res.data
        }
      })
    },
    pay2() {
      this.price = 129.00;
      this.name = '12个月';
      this.day = 365;
      var data =
      {
        total_amount: this.price,//价格（小数点后保留两位）
        Subject: this.name,//商品名称
        Days: this.day,//开通天数
      };
      Payment(data).then(res => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      })
    },
    pay3() {
      this.price = 99.00;
      this.name = '6个月';
      this.day = 183;
      var data =
      {
        total_amount: this.price,//价格（小数点后保留两位）
        Subject: this.name,//商品名称
        Days: this.day,//开通天数
      };
      Payment(data).then(res => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      })
    },
    pay4() {
      this.price = 59.00;
      this.name = '3个月';
      this.day = 91;
      var data =
      {
        total_amount: this.price,//价格（小数点后保留两位）
        Subject: this.name,//商品名称
        Days: this.day,//开通天数
      };
      Payment(data).then(res => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      })
    },
    pay5() {
      this.price = 39.00;
      this.name = '1个月';
      this.day = 30;
      var data =
      {
        total_amount: this.price,//价格（小数点后保留两位）
        Subject: this.name,//商品名称
        Days: this.day,//开通天数
      };
      Payment(data).then(res => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      })
    }
  },
}
</script>

<style lang="less">
.pay {
  padding-top: 30px;
}
.title {
  width: 100%;
  height: 74px;
  font-size: 56px;
  text-align: center;
}
.setMeal {
  height: 412px;
  margin: 100px auto 0;
  padding: 0 6.5%;
  div {
    min-width: 242px;
    width: 18%;
    height: 100%;
    background: #f5f5f5;
    border-radius: 10px;
    float: left;
    margin-right: 2%;
    padding: 0 30px;
    position: relative;
  }
  div:nth-child(1) {
    margin-left: 1%;
  }
  div:nth-child(5) {
    margin-right: 1%;
  }
  .click {
    background-color: #0b7bf6;
    .preferential {
      min-width: 122px;
      padding: 0;
      margin: 0;
      height: 44px;
      background-color: #fe605f;
      color: #fff;
      border-radius: 0 10px 0 10px;
      text-align: center;
      line-height: 44px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .name {
      min-width: 200px;
      width: 100%;
      height: 18px;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      background: transparent;
      text-align: center;
      font-family: "黑体";
      margin-top: 70px;
    }
    .price {
      min-width: 200px;
      width: 100%;
      height: 90px;
      font-size: 66px;
      line-height: 90px;
      color: #fff;
      text-align: center;
      background: transparent;
      margin-top: 30px;
    }
    .originalPrice {
      min-width: 200px;
      width: 100%;
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      text-align: center;
      background: transparent;
      margin-top: 30px;
      text-decoration: line-through;
    }
    .buy {
      min-width: 200px;
      width: 100%;
      height: 56px;
      line-height: 56px;
      color: #fff;
      background: #fe605f;
      border-radius: 10px;
      text-align: center;
      margin-top: 30px;
      cursor: pointer;
    }
    .activity {
      min-width: 20px;
      width: 100%;
      height: 16px;
      font-size: 14px;
      color: #fff;
      background: transparent;
      text-align: center;
      margin-top: 20px;
    }
  }
  .noclick {
    background-color: #f5f5f5;
    .preferential {
      min-width: 122px;
      padding: 0;
      margin: 0;
      height: 44px;
      background-color: #0b7bf6;
      color: #fff;
      border-radius: 0 10px 0 10px;
      text-align: center;
      line-height: 44px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .name {
      min-width: 200px;
      width: 100%;
      height: 18px;
      font-size: 18px;
      font-weight: 700;
      color: #666;
      background: transparent;
      text-align: center;
      font-family: "黑体";
      margin-top: 70px;
    }
    .price {
      min-width: 200px;
      width: 100%;
      height: 90px;
      font-size: 66px;
      line-height: 90px;
      color: #000;
      text-align: center;
      background: transparent;
      margin-top: 30px;
    }
    .originalPrice {
      min-width: 200px;
      width: 100%;
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      text-align: center;
      background: transparent;
      margin-top: 30px;
      text-decoration: line-through;
    }
    .buy {
      min-width: 200px;
      width: 100%;
      height: 56px;
      line-height: 56px;
      color: #fff;
      background: #0b7bf6;
      border-radius: 10px;
      text-align: center;
      margin-top: 30px;
      cursor: pointer;
    }
    .activity {
      min-width: 20px;
      width: 100%;
      height: 16px;
      font-size: 14px;
      color: #999;
      background: transparent;
      text-align: center;
      margin-top: 20px;
    }
  }
}
.privilege {
  height: 252px;
  width: 86%;
  margin: 0 auto;
  // background: skyblue;
  margin-top: 50px;
  .top {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    border-bottom: 2px solid #eee;
    padding-bottom: 30px;
    margin-bottom: 30px;
    span {
      font-size: 14px;
      color: #999;
      font-weight: normal;
      margin-left: 20px;
    }
  }
  .bottom {
    li {
      width: 20%;
      font-size: 14px;
      color: #666;
      float: left;
      margin: 10px 5% 10px 0;
      .icon {
        vertical-align: -4px;
        margin-right: 30px;
      }
      span{
        float: right;
      }
    }
  }
}
</style>
